import { ReactNode } from 'react'
import { Navigate } from 'react-router'
import { useShowcaseAccess } from './access'

/**
 * Guard для роутов /showcase/*. Если юзер не в whitelist Phase 1 — редирект на /dashboard.
 * После Phase 3 (rollout всем) — этот guard можно убрать, оставив просто доступ.
 */
export function RequireShowcaseAccess({ children }: { children: ReactNode }) {
  const allowed = useShowcaseAccess()
  if (!allowed) {
    return <Navigate to="/dashboard" replace />
  }
  return <>{children}</>
}
